document.addEventListener('sideMenuContentCreated', () => {
    const menuItems = document.querySelectorAll('.mainUl li');
    const specialMenuItems = document.querySelectorAll('[data-menu-id="specialMenuItem"]');
    specialMenuItems.forEach((element) => {
        element.classList.add('specialMenuItem');
        const svgWrap = document.createElement('span');
        svgWrap.classList.add('svgWrap');
        element.appendChild(svgWrap);
    });
    menuItems.forEach((menuItem) => {
        const submenu = menuItem.querySelector('ul');
        if (submenu) {
            menuItem.classList.add('has-submenu');
            submenu.style.display = 'none';

            const link = menuItem.querySelector('a');
            if (!link.querySelector('.arrow')) {
                const arrow = document.createElement('span');
                arrow.classList.add('arrow');
                link.appendChild(arrow);

                arrow.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    const openSubmenus = menuItem.parentNode.querySelectorAll('.mainUl li ul.show');
                    openSubmenus.forEach((openSubmenu) => {
                        if (openSubmenu !== submenu && !submenu.contains(openSubmenu)) {
                            hideSubmenu(openSubmenu);
                        }
                    });

                    toggleSubmenu(submenu, arrow);
                });

                const activeChild = submenu.querySelector('.current');
                if (activeChild) {
                    showSubmenu(submenu, arrow);
                }
            }
        }
    });

    function toggleSubmenu(submenu, arrow) {
        if (submenu.classList.contains('show')) {
            hideSubmenu(submenu);
        } else {
            showSubmenu(submenu, arrow);
        }
    }

    function showSubmenu(submenu, arrow) {
        submenu.style.display = 'block';
        submenu.classList.add('show');
        arrow.classList.add('expanded');
    }

    function hideSubmenu(submenu) {
        submenu.style.display = 'none';
        submenu.classList.remove('show');
        const arrow = submenu.previousElementSibling.querySelector('.arrow');
        if (arrow) {
            arrow.classList.remove('expanded');
        }
    }
});

document.addEventListener('DOMContentLoaded', () => {
    const activeSubmenus = document.querySelectorAll('.mainUl li ul .current, .mainUl li ul .current_ancestor');
    activeSubmenus.forEach((activeChild) => {
        const submenu = activeChild.closest('ul');
        if (submenu) {
            submenu.style.display = 'block';
            submenu.classList.add('show');
            const arrow = submenu.previousElementSibling.querySelector('.arrow');
            if (arrow) {
                arrow.classList.add('expanded');
            }
        }
    });
});
